import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from '../../../stores';
import * as styles from "../../Megamenu.css";

export interface IBurgerbarProps {
  navigatorStore?: NavigatorStore;
}

@inject('navigatorStore')
@observer
export class Burgerbar extends React.Component<IBurgerbarProps> {

  constructor(props: IBurgerbarProps) {
    super(props);
  }

  public render(): JSX.Element {
    return (

      <div
        className={styles.IA_burgerBar}
        style={{ 
          backgroundColor: this.props.navigatorStore.navigator != undefined ? this.props.navigatorStore.navigator.design.topItems.backgroundColor : "none",
          width: this.props.navigatorStore.isMobile ? "100%" : 300
        }}
      >
        {this.props.navigatorStore.topItems}
      </div>
    );
  }
}